import {useMutation} from '@apollo/client';
import {CREATE_CART} from "../productTypeDefs";

export const useMutationCreateCart = (options?: any): any => (
  useMutation(CREATE_CART, options)
);
